//import { Button } from 'grommet';
//import styled from 'styled-components';
import {
//  DocumentUpdate,
  Cloud,
  Group,
  StatusInfo,
  Link,
//  Aruba,
//  PhoneVertical,
//  ShieldSecurity,
//  Support,
//  UserAdd,
} from 'grommet-icons';

// styled component to create custom orange button
// const StyledButton = styled(Button)`
//   background: ${props => props.theme.global.colors['orange!']};
//   color: ${props => props.theme.global.colors['text-strong'].light};
//   &:hover {
//     background: ${props => props.theme.global.colors['orange!']};
//     color: ${props => props.theme.global.colors['text-strong'].light};
//   }
// `;

export const SitesDataProd = [
  // {
  //   cta: <StyledButton label="Launch" />,
  //   background: 'yellow',
  //   title: 'Aruba Network Manager',
  //   description: `Network configuration and operations made simple. Your 
  //   network on a single pane of glass.`,
  //   descriptionColor: 'text-strong',
  //   icon: <Aruba color="plain" />,
  // },
  {
    title: 'HPE IT Cloud Services',
    description: 'In need of cloud services (private or public)? HPE IT and Greenlake have you covered!',
    icon: <Cloud color="blue!" />,
    cta: 'Launch',
    url: 'https://common.cloud.hpe.com/',
  },  
  {
    title: 'HPE Value Chain',
    description: 'As we increase our E2E outcome focus our Value Chain definition and E2E orientation play an enabling role.',
    icon: <Link color="yellow!" />,
    cta: 'Learn more',
    url: '/valuechain',
  }, 
  {
    title: 'HPE Enterprise Architecture',
    description: 'Interested in knowing more about HPE\'s Enterprise Architecture function?',
    icon: <Group color="purple!" />,
    cta: 'Learn more',
    url: '/ea',
  },     
  {
    title: 'Status Central Sites',
    description: 'HPE\'s home for our externally and internally facing status sites.',
    icon: <StatusInfo color="orange!" />,
    cta: 'Launch',
    url: 'https://home.hpe-status.com/',
  },

  // {
  //   cta: 'Launch',
  //   title: 'External Status Central',
  //   description:
  //     'HPE\'s partner and employee facing Status Central site for critical systems (commerce, etc.).',
  //   icon: <Cloud color="blue!" />,
  //   url: 'https://hpe-status.com/',
  // },
  // {
  //   cta: 'Launch',
  //   title: 'Global Workplace',
  //   description:
  //     'Global Workplace\'s internal Status Central site for HPE facilities world wide.',
  //   icon: <Group color="purple!" />,
  //   url: 'https://workplace.hpe-status.com/',
  // },

  // {
  //   cta: 'Set up SAML SSO',
  //   title: 'Add a SSO/SAML connection',
  //   description: `Easily add extra protection to your HPE Account by connecting 
  //   to your company's IDP.`,
  //   icon: <ShieldSecurity color="blue!" />,
  // },
  // {
  //   cta: 'Enable MFA',
  //   title: 'Set up multi-factor authentication  ',
  //   description:
  //     'Easily add extra protection by requiring access to your phone.',
  //   icon: <PhoneVertical color="purple!" />,
  // },
  // {
  //   cta: 'Release notes',
  //   title: 'Get release notes',
  //   description:
  //     'Stay up to date with the latest release notes from HPE Common Cloud.',
  //   icon: <DocumentUpdate color="blue!" />,
  // },
];